"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function ViewInEnv() {
  const pathname = usePathname();
  if (process.env.NODE_ENV === "production") return null;

  return (
    <Link href={"https://luminar-devboard.tunis.events" + pathname || "#"}>
      <div className="fixed z-50 flex items-center justify-center h-6 p-3 ml-8 font-mono text-xs text-white bg-gray-800 rounded-full bottom-1 w-fit">
        <div className="block">view in pre-prod</div>
      </div>
    </Link>
  );
}
